import { ReactElement, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonFunctionsCrumbs } from '../constants';
import FormFunction, { FunctionForm } from 'system/components/functions/form';
import { useNavigate } from 'react-router-dom';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
// import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { toast } from 'react-toastify';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';

const FunctionsNew = (): ReactElement => {
  const navigate = useNavigate();
  const { post: insertFunction } = useHttpFetch(`${__MANAGEMENT_API_URL__}/funzioni`);

  const onOk = useCallback(
    (form: FunctionForm | undefined) => {
      insertFunction({
        key: { codice: form?.id },
        nome: form?.name,
        entita: form?.entity,
        evento: form?.event,
        note: form?.contextLastUpdate,
      }).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/funzioni');
      });
    },
    [insertFunction, navigate]
  );

  return (
    <>
      <Breadcrumbs items={[...CommonFunctionsCrumbs, { name: 'Nuova Funzione' }]} />
      <FormFunction
        title="Nuova Funzione"
        onOk={onOk}
        onCancel={() => {
          navigate('/sistema/funzioni');
        }}
      />
    </>
  );
};

FunctionsNew.displayName = 'Functions Detail';

export default FunctionsNew;
